import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SeoHead, CheckIcon, FaqSection } from '../seo/SeoShared';
import { buildEffyFuelSchema } from '../seo/seoSchemas';
import { EFFY_FUEL_PRODUCT, FUEL_FEATURES, FUEL_FAQS, FUEL_URL } from './effyFuelContent';
import { FuelCta } from './FuelCta';
import './EffyOrder.css';
import '../seo/SeoPages.css';
import './EffyFuel.css';

// /products/effy-fuel — same layout as the Effy Order page: hero, then one section per feature.
export default function EffyFuel() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="oi-page-v2">
      <SeoHead
        path={EFFY_FUEL_PRODUCT.path}
        title="Petrol Bunk Management Software – Shift Sales, Credit & Stock | Effy Fuel"
        description="Effy Fuel helps petrol bunk owners close every shift quickly, keep track of credit customers, check salesperson cash and always know their fuel and oil stock."
        breadcrumbName={EFFY_FUEL_PRODUCT.name}
        faqs={FUEL_FAQS}
        extraSchema={buildEffyFuelSchema()}
      />

      <section className="oi-hero-v2 seo-hero--center">
        <div className="seo-hero__center">
          <div className="oi-badge-v2">Introducing Effy Fuel</div>
          <h1 className="oi-hero-v2__title">
            Run your petrol bunk with <span className="text-gradient">less paperwork and more confidence.</span>
          </h1>
          <p className="oi-hero-v2__subtitle">
            Close every shift in minutes, know who owes you money, and always see how much stock is left. Made for petrol bunk owners, and it works on your phone.
          </p>
          <div className="oi-hero-v2__actions seo-hero__actions">
            <a href={`${FUEL_URL}/signup`} className="btn-v2 btn-v2--primary">Try it free</a>
            <a href={`${FUEL_URL}/login`} className="btn-v2 btn-v2--secondary">Sign In</a>
          </div>
          <Link to={EFFY_FUEL_PRODUCT.featuresPath} className="ef-hero-link">See all features →</Link>
        </div>
      </section>

      <div className="oi-features-wrapper">
        {FUEL_FEATURES.map(({ id, Icon, label, heading, description, points }, idx) => (
          <section key={id} className={`oi-feature-v2 ${idx % 2 !== 0 ? 'oi-feature-v2--reverse' : ''}`}>
            <div className="oi-feature-v2__container">
              <div className="oi-feature-v2__content">
                <span className="oi-feature-v2__label">{label}</span>
                <h2 className="oi-feature-v2__title">{heading}</h2>
                <p className="oi-feature-v2__desc">{description}</p>
                <ul className="oi-feature-v2__list">
                  {points.map(point => (
                    <li key={point}>
                      <CheckIcon />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="oi-feature-v2__visual">
                <div className="ef-visual" aria-hidden="true">
                  <Icon />
                </div>
              </div>
            </div>
          </section>
        ))}
      </div>

      <FuelCta />

      <FaqSection faqs={FUEL_FAQS} />
    </div>
  );
}
